import { SsoStatusState } from '@layout/sso-status/store/states/sso-status.state';

export const ssoStatusState = [SsoStatusState];
